import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxFileUploadComponent } from './rx-file-upload.component';
import { RxUploadModule } from '@nrwl/rx-upload';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  imports: [CommonModule, RxUploadModule, MatProgressBarModule, RxFileUploadComponent],
  exports: [RxFileUploadComponent, RxFileUploadComponent],
})
export class RxFileUploadModule {}
